function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import { FormattedMessage } from 'react-intl';
import ReactTooltip from 'react-tooltip';
import { motion } from 'framer-motion';
import map from 'lodash/map';
import Dots from 'svg/dots.svg';
import history from 'helpers/history';
import Avatar from 'components/Avatar';
import Link from 'components/Link';
import Button from 'components/Form/Button';
import { useAction, useUrl } from 'hooks';
import App from 'modules/App';
import * as actions from '../../actions';
import * as constants from '../../constants';
import * as selectors from '../../selectors';
import messages from '../../messages';
import styles from './MyDoctorsPage.pcss';
const MyDoctorsPage = ()=>{
    useStyles(styles);
    const direction = useSelector(App.selectors.direction);
    const openDropdownId = useSelector(App.selectors.dropdown);
    const sharingRequests = useSelector(selectors.sharingRequests);
    const setBeingApprovedSharingRequestId = useAction(actions.setBeingApprovedSharingRequestId);
    const openModal = useAction(App.actions.openModal);
    const setFormContext = useAction(App.actions.setFormContext);
    const onOpenDropdown = useAction(App.actions.openDropdown);
    const onCloseDropdown = useAction(App.actions.closeDropdown);
    const approvedSharingRequests = sharingRequests.filter((request)=>request.sharingStatus === 'Approved');
    const enrollingSharingRequests = sharingRequests.filter((request)=>request.sharingStatus === 'PendingEnrolling' || request.sharingStatus === 'Enrolling');
    const onReauthorizeAccess = (evt, sharingRequest)=>{
        evt.preventDefault();
        setBeingApprovedSharingRequestId(sharingRequest.sharingRequestId);
        openModal(constants.APPROVE_DATA_SHARING_MODAL);
    };
    const onRevokeAccess = (evt, sharingRequest)=>{
        evt.preventDefault();
        setFormContext(constants.REVOKE_ACCESS_FORM, sharingRequest);
        openModal(constants.REVOKE_ACCESS_MODAL);
    };
    const visitHistoryUrl = useUrl('mobile-my-visits-history');
    const onVisitHistory = ()=>{
        history.push(visitHistoryUrl);
    };
    const enrollInClinicUrl = useUrl('mobile-enroll-in-clinic');
    const onEnrollInTheClinic = ()=>{
        history.push(enrollInClinicUrl);
    };
    const onClickContent = (evt)=>{
        evt.stopPropagation();
        onCloseDropdown();
    };
    useEffect(()=>{
        ReactTooltip.rebuild();
    }, [
        sharingRequests
    ]);
    const renderOptions = (onClick, Menu)=>/*#__PURE__*/ _jsxs("div", {
            className: styles.sharingRequest__dots,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    onClick: (evt)=>{
                        evt.preventDefault();
                        evt.stopPropagation();
                        onClick();
                    },
                    onKeyDown: ()=>{},
                    className: "d-flex justify-content-center align-items-center",
                    children: /*#__PURE__*/ _jsx(Dots, {})
                }),
                /*#__PURE__*/ _jsx(Menu, {})
            ]
        });
    const renderMenuSharingLink = (sharingRequest)=>{
        const expectedOpenDropdownId = `${constants.APPROVED_SHARING_REQUEST_DROPDOWN}-${sharingRequest.sharingRequestId}`;
        if (openDropdownId !== expectedOpenDropdownId) {
            return null;
        }
        return /*#__PURE__*/ _jsx(motion.div, {
            initial: {
                width: 0
            },
            animate: {
                width: 'auto'
            },
            exit: {
                width: 0
            },
            transition: {
                ease: 'easeOut',
                duration: 0.15
            },
            className: "dropdownMenu__container dropdownMenu__container--oposite ml-3",
            children: /*#__PURE__*/ _jsxs("ul", {
                className: "dropdownMenu__actions",
                children: [
                    /*#__PURE__*/ _jsx("li", {
                        className: "dropdownMenu__action",
                        children: /*#__PURE__*/ _jsx(Link, {
                            to: "",
                            onClick: (evt)=>onReauthorizeAccess(evt, sharingRequest),
                            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.reauthorizeAccess))
                        })
                    }),
                    /*#__PURE__*/ _jsx("li", {
                        className: "dropdownMenu__action",
                        children: /*#__PURE__*/ _jsx(Link, {
                            to: "",
                            onClick: (evt)=>onRevokeAccess(evt, sharingRequest),
                            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.revokeAccess))
                        })
                    })
                ]
            })
        });
    };
    const renderApprovedSharingRequest = (sharingRequest)=>{
        const hcpName = sharingRequest.hcp ? `${sharingRequest.hcp.firstName} ${sharingRequest.hcp.lastName}` : sharingRequest.clinic.name;
        const clinicName = sharingRequest.hcp ? sharingRequest.clinic.name : /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.unassigned));
        const avatar = sharingRequest.hcp ? sharingRequest.hcp.avatar : sharingRequest.clinic.logo;
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.sharingRequest,
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.sharingRequest__profile,
                    children: [
                        /*#__PURE__*/ _jsx(Avatar, {
                            avatarImg: avatar,
                            name: hcpName,
                            imgClassName: "sidebar__avatar",
                            className: "sidebar__avatar"
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: styles.sharingRequest__hcpNameContainer,
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: cn(styles.sharingRequest__hcpCellHcpName, 'brand__h2'),
                                    children: hcpName
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: cn(styles.sharingRequest__hcpCellClinicName, 'text--small text--light'),
                                    children: clinicName
                                })
                            ]
                        })
                    ]
                }),
                renderOptions(()=>onOpenDropdown(`${constants.APPROVED_SHARING_REQUEST_DROPDOWN}-${sharingRequest.sharingRequestId}`), ()=>renderMenuSharingLink(sharingRequest))
            ]
        }, sharingRequest.sharingRequestId);
    };
    const renderApprovedSharingRequests = ()=>/*#__PURE__*/ _jsx("div", {
            className: styles.sharingReguestsContainer,
            children: map(approvedSharingRequests, renderApprovedSharingRequest)
        });
    const renderEnrollingSharingRequests = ()=>/*#__PURE__*/ _jsx("div", {
            className: cn(styles.sharingReguestsContainer, 'mt-4'),
            children: map(enrollingSharingRequests, (request)=>{
                const infoMessage = request.sharingStatus === 'Enrolling' ? messages.infos.requestIsPending : messages.infos.requestIsInProgress;
                return /*#__PURE__*/ _jsx("div", {
                    className: cn(styles.sharingRequest, styles['sharingRequest--enrolling']),
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: styles.sharingRequest__profile,
                        children: [
                            /*#__PURE__*/ _jsx(Avatar, {
                                avatarImg: request.clinic.logo,
                                name: request.clinic.name,
                                imgClassName: "sidebar__avatar",
                                className: "sidebar__avatar"
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: styles.sharingRequest__hcpNameContainer,
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: cn(styles.sharingRequest__hcpCellHcpName, 'brand__h2'),
                                        children: request.clinic.name
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: cn(styles.sharingRequest__hcpCellClinicName, 'text--small text--light'),
                                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, infoMessage))
                                    })
                                ]
                            })
                        ]
                    })
                }, request.sharingRequestId);
            })
        });
    const renderActions = ()=>/*#__PURE__*/ _jsxs("div", {
            className: styles.myDoctors__actionsContainer,
            children: [
                /*#__PURE__*/ _jsx(Button, {
                    styleModifier: "primary",
                    labelMessage: messages.buttons.visitHistory,
                    onClick: onVisitHistory
                }),
                /*#__PURE__*/ _jsx(Button, {
                    styleModifier: "primary",
                    className: "btn--filled",
                    labelMessage: messages.buttons.enrollInTheClinic,
                    onClick: onEnrollInTheClinic
                })
            ]
        });
    const renderContent = ()=>/*#__PURE__*/ _jsx("div", {
            className: styles.myDoctors__contentBox,
            onClick: (evt)=>onClickContent(evt),
            onKeyDown: ()=>{},
            children: /*#__PURE__*/ _jsxs("div", {
                children: [
                    renderApprovedSharingRequests(),
                    renderEnrollingSharingRequests()
                ]
            })
        });
    const renderTooltip = ()=>{
        if (!process.env.BROWSER) {
            return null;
        }
        return /*#__PURE__*/ _jsx(ReactTooltip, {
            id: "sidebar",
            place: direction === 'ltr' ? 'right' : 'left',
            type: "dark",
            effect: "solid",
            offset: direction === 'ltr' ? {
                left: -10
            } : {
                right: -8
            }
        });
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            renderContent(),
            renderActions(),
            renderTooltip()
        ]
    });
};
export default MyDoctorsPage;
